import { TableContainer } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Typography } from '../../atoms/Typography';

import { COLORS } from '../../../configs/colors';

export const Topic = styled(Typography)`
  font-size: 18px;
  line-height: 28.8px;
`;

export const StyledTableContainer = styled(TableContainer)`
  border: 1px solid ${COLORS.CardBorder};
  border-radius: 5px;
  max-height: 49vh;
  overflow: auto;
`;